import s from "./AddCourseMenu.less";
import Select from "~/shared/ui/Fields/Select";
import Input from "../Input/index";
import Button from "~/shared/ui/Fields/Button";
import React, { useEffect } from "react";
import { useGetFilteredCoursesForSelect } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/hooks";

type Props = {
  level;
  control: any;
  handleOnChangeCourse;
  currentCourseCertificationPeriodWatcher;
  courseStatusError: string;
  handleAddCourse: () => void;
  handleDelete: () => void;
  setCourseStatusError: (value: string) => void;
  watch: any;
  usedCoursesId: string[];
  levelId: string;
};
const AddCourseMenu = (props: Props) => {
  const {
    level,
    control,
    handleOnChangeCourse,
    currentCourseCertificationPeriodWatcher,
    courseStatusError,
    handleAddCourse,
    handleDelete,
    setCourseStatusError,
    watch,
    usedCoursesId,
    levelId,
  } = props;

  useEffect(() => {
    if (courseStatusError) {
      setCourseStatusError(null);
    }
  }, []);

  const { filteredCourses, intersectionObserverCourseId, searchTextCourseId } =
    useGetFilteredCoursesForSelect({ usedCoursesId, levelId });

  const currentCourseWatcher = watch(`${level.id}course`);
  return (
    <div className={s.input_fields}>
      <div className={s.item}>
        <Select
          label={"Курс"}
          name={`${level.id}course`}
          control={control}
          onScrollBottom={intersectionObserverCourseId}
          optionObjects={filteredCourses}
          getSearchText={searchTextCourseId}
          onChangeDecorator={(value) => handleOnChangeCourse(value, "course")}
          defaultValue={{ value: null, label: "Выберите курс" }}
        />
      </div>
      {currentCourseWatcher && (
        <div className={s.item}>
          <Input
            name={"certificationPeriod"}
            label={"Срок действия сертификата"}
            disabled
            value={
              currentCourseCertificationPeriodWatcher
                ? currentCourseCertificationPeriodWatcher
                : "Бессрочно"
            }
            className={s.input_wrapper}
          />
        </div>
      )}
      <div className={s.item}>
        <Select
          label={"Статус"}
          name={`${level.id}status`}
          optionObjects={[
            { value: "active", label: "Активный" },
            { value: "inactive", label: "Неактивный" },
          ]}
          control={control}
          onChangeDecorator={(value) => handleOnChangeCourse(value, "status")}
          defaultValue={{ value: null, label: "Выберите статус" }}
        />
      </div>
      <div className={s.item}>
        {courseStatusError && (
          <span className={s.error_message}>{courseStatusError}</span>
        )}
      </div>
      <div className={s.buttons}>
        <Button small={true} txtBtn={"Добавить"} onClick={handleAddCourse} />
        <Button small={true} txtBtn={"Отменить"} onClick={handleDelete} />
      </div>
    </div>
  );
};

export default AddCourseMenu;
